import { TranslationOutlined } from "@ant-design/icons";
import styled from "styled-components";

const AnimatedTranslationIcon = styled(TranslationOutlined)`
  @keyframes BlinkingTranslationIcon-blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  animation: BlinkingTranslationIcon-blink 1s infinite;
  color: ${p => p.theme.colorPrimary};
`;

export default AnimatedTranslationIcon;
